import logo from '@/assets/logo.svg';
import { centerChildren } from '@/components/utils/centering';
import { VerticalStack } from '@/components/utils/linearLayouts';
import { Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';

export const NotFoundPage = ({ title = 'Axle Health' }: { title?: string }) => {
    return (
        <VerticalStack spacing={6} sx={{ height: '100vh', ...centerChildren }}>
            <Helmet>
                <title>Not Found{title ? ` | ${title}` : ''}</title>
            </Helmet>
            <img
                src={logo}
                style={{
                    height: 100,
                }}
                alt=''
            />
            <Typography variant='h2'>Sorry, we couldn’t find that page.</Typography>
        </VerticalStack>
    );
};
